import { createStyles, makeStyles } from "@material-ui/core";
import React, { useReducer, useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setDialogHandle, setDialogTitle } from "../../actions/dialog";
import { subscriptionsMap } from "../../const/subscriptions";
import {  VENUES } from "../../const/URL.const";
import useHubspot from "../../hooks/useHubspot";
import { IReduxAppState } from "../../reducers";
import { IDialogChildComponent } from "../../reducers/dialog";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { ISelectOptions } from "../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { EEnvironmentStages } from "../../yoello-lib/modules/environments/services";
import hostClient from "../../yoello-lib/modules/host/HostClient";
import { hosts } from "../../yoello-lib/modules/host/Hosts";
import { CompletedContainer } from "../signup/completed/CompletedContainer";
import { SubscriptionForm } from "../signup/forms/SubscriptionForm";
import { CreateVenue } from "../signup/newVenue/CreateVenue";
import { NewVenueForm } from "../signup/newVenue/NewVenueForm";
import { setHubspotId, setLeadId, setStage, setSubscription } from "../signup/newVenue/state/newVenue.action";
import { initalState, newVenueReducer } from "../signup/newVenue/state/newVenue.state";
import { NewVenueStages } from "../signup/newVenue/types";
import { OnboardingSources } from "../signup/types";
import { VenueSelectionDialog } from "./VenueSelectionDialog";


interface INewVenueDialogProps extends IDialogChildComponent {
    history: any;
}
export interface INewVenueData {
    venueDetails: {
        venue_name?: string;
        venue_location?: ISelectOptions;
    }
    onboarding_source: string;
};

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            minWidth: '40rem',
            marginLeft: "1rem",
            [theme.breakpoints.down('sm')]: {
                minWidth: 0,
            }
        }
    }))

const titles: Record<string, string> = {
    [NewVenueStages.VenueDetails]: 'signup.newVenue.addANewVenue',
    [NewVenueStages.VenueSubscription]: 'signup.titles.yoelloSubscription',
    [NewVenueStages.Completed]: ''
}

export function NewVenueDialog({ onClose, onDialogClose, history }: INewVenueDialogProps) {
    const [state, dispatch] = useReducer(newVenueReducer, initalState);
    const { leadId, selectedSubscription, hubspotId } = state;
    const { t } = useTranslation();
    const classes = useStyles();
    const dispatcher = useDispatch();
    const merchant = useSelector((state: IReduxAppState) => state.merchant)
    const { apiData, isError, callAPI, isLoading } = useAPIV2<any>(APIExtensions.registration, { query: "leads" });
    const selectedVenueId = useSelector(
        (state: IReduxAppState) => state.selectedVenueId
    );
    const venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData);
    const [venueLocation, setVenueLocation] = useState<any>(undefined);

    const { getHubspotForm, destroyHubspotForm } = useHubspot();

    useEffect(() => {
        if (apiData && !isError) {
            if (apiData.id) {
                dispatch(setLeadId(apiData.id));
                dispatch(setHubspotId(apiData.hubspot_id))
            }
        } else if (apiData === undefined) {
            callAPI(HTTPMethods.POST, {
                body: {
                    first_name: merchant.first_name,
                    last_name: merchant.last_name,
                    contact_phone: merchant.contact_phone,
                    contact_email: merchant.contact_email,
                    onboarding_source: merchant.onboarding_source,
                    auth0_id: merchant.auth0_id,
                    reseller: merchant.reseller
                }
            }).then((results) => {
                if (results.isSuccessful) {
                    console.log(results.data)
                    dispatch(setLeadId(results.data.lead_id));
                    dispatch(setHubspotId(results.data.hubspot_id));
                }
            })
        }
        // eslint-disable-next-line
    }, [apiData, isError]);


    useEffect(() => {
        if (state.stage) {
            dispatcher(setDialogTitle(t(titles[state.stage])));
        }
        // eslint-disable-next-line
    }, [state.stage]);

    function setVenueSubscription(id: string | null) {
        dispatch(setSubscription(id));
    }

    function goBackFromSub() {
        dispatch(setStage(NewVenueStages.VenueDetails));
    }

    function onGoToVenue() {
        history.push(VENUES);
        onDialogClose!();
    }

    async function callLeads<T>(data: T) {
        await callAPI(HTTPMethods.PATCH, {
            body: {
                ...data,
                hubspot_id: hubspotId
            },
            query: `leads/${leadId}`
        });
    }
    async function onComplete() {
        if (leadId) {
            const paymentPackage = selectedSubscription ? subscriptionsMap[selectedSubscription] : undefined;
            if (paymentPackage) {
                await callLeads({ pricing_plan: paymentPackage });
            }
        }
        dispatch(setStage(NewVenueStages.Completed));

        if(process.env.REACT_APP_ENVIRONMENT === EEnvironmentStages.production){
            getHubspotForm();
        }else{
            destroyHubspotForm();
        }

    }

    function goBackToList() {
        dispatcher(
            setDialogHandle({
                Component: VenueSelectionDialog,
                ComponentProps: {
                    history:history
                },
                dialogTitle: t("venueSelection.title"),
                isFormDialog: false
            })
        );
    };
    useEffect(() => {
        getVenueLocation()
    // eslint-disable-next-line
    }, [])
    

    function getVenueLocation() {
        if (merchant) {
            const onboarding_source  = venue?.onboarding_source;
            if (hostClient.host === hosts.bna) {
                setVenueLocation({ name: "Canada", value: "CA"});
                return ;
            }
            switch (onboarding_source) {
                case OnboardingSources.partners:
                    setVenueLocation(undefined);
                    return;
                case OnboardingSources.zerobubble:
                    setVenueLocation({ name: "Malta", value: "MT" });
                    return ;
                case OnboardingSources.bna:
                    setVenueLocation({ name: "Canada", value: "CA"});
                    return ;
                default:
                    setVenueLocation({ name: "United Kingdom", value: "GB" });
                    return ;
            }
        }   
    };

    function renderEntity() {
        switch (state.stage) {
            case NewVenueStages.VenueDetails:
                return <NewVenueForm onClose={onClose} callLeads={callLeads}
                    dispatch={dispatch} venueData={{ venue_location: venueLocation }} host={venue?.onboarding_source}/>;
            case NewVenueStages.VenueSubscription:
                return <SubscriptionForm
                    selectSubscription={setVenueSubscription}
                    selectedSubscription={state.selectedSubscription}
                    isLoading={isLoading}
                    goBack={goBackFromSub}
                    onSubmit={onComplete}
                    venueData={state.VenueDetails}
                    isDialogForm={true}
                />
            case NewVenueStages.Completed:
                return <CompletedContainer
                    getStartedTextKey="signup.newVenue.getStartedInternal"
                    setSubscription={setVenueSubscription} venueData={state.VenueDetails}
                    isAvailable={state.selectedSubscription === "1"} onBack={goBackToList}
                    AvailableComponent={
                        <CreateVenue onFinishFunction={onGoToVenue} goBack={goBackToList}
                            data={state.VenueDetails} />
                    } />
            default:
                return <div></div>
        }
    }

    return <div className={classes.root}>{renderEntity()}</div>
}